import React from "react";

const Banner = ({ image }) => {
  return <img className="w-full" src={image} alt="Limau Bendi School Banner" />;
};

export default Banner;
